import WidgetSearchField from "../../../widgets/widget-search-field";

export default class MobileNavSearch {
	constructor($root) {
		this.$root = $root;
		this.$initialScreen = null;
		this.$progressScreen = null;
		this.$resultScreen = null;
		this.$errorScreen = null;

		this.siteLang = document.querySelector('html').lang;
		this.searchField = null;

		this.init();
	}

	init() {
		this.searchField = new WidgetSearchField({
			$root: this.$root.querySelector('.mobile-nav-search_field'),
			action: (value) => {
				if (value) {
					location.href = location.origin + (this.siteLang === 'ru' ? '/ru' : '') + '/search?q=' + value;
				} else {
					this.searchField.dropState();
				}
			},
			subscriptions: [
				{
					event: 'searchInput',
					callback: ({ detail }) => {
						if (detail && this.searchField.$action.textContent !== craft.localization.search) {
							this.searchField.$action.textContent = craft.localization.search;
						} else if (!detail && this.searchField.$action.textContent !== craft.localization.cancel) {
							this.searchField.$action.textContent = craft.localization.cancel;
						}
					}
				}
			]
		});
	}
}